var Toggle = new Class({
	Implements: [Events, Options],
	options: {
		cls: 'w_toggle',
		divider : true
	},

	initialize: function(element, options){
		this.setOptions(options);		
		this._element = element || document.getElement('.w_toggle');
		
		if(this._element){
			this.build();
		}		
	},

	build: function(){
		var self = this;
		this._toggles = this._element.getElements('li');

		if(this._toggles && this._toggles.length > 1){
			this._toggles.each(function(_el, i){
				self.add_click(_el);

				if(i > 0 && self.options.divider == true){
					var _divider = new Element('li.divider');
					_divider.inject(_el, 'before');
					
					_divider.addEvent('click', function(e){
						if(_el.hasClass('_selected')){
							_divider.getPrevious('li').fireEvent('click', [e]);
						}else{
							_el.fireEvent('click', [e]);
						}
					});
				}
			});

			if(this._element.getElement('li._selected')){
				this._element.getElement('li._selected').fireEvent('click');
			}else{
				this._toggles[0].fireEvent('click');
			}
		}
	},

	add_click: function(_el){
		var self = this;

		_el.addEvents({
			'click': function(e){
				_el.fireEvent('select', [e]);
			},

			'select': function(e){
				if(self._active_el === _el) return;
				
				_el.addClass('_selected');

				if(self._active_el){
					self._active_el.removeClass('_selected');
				}

				self._active_el = _el;

				self.select_flow();

				self.fireEvent('toggle', [_el]);
				self._element.fireEvent('toggle', [_el]);
			}
		});
	},

	select_flow: function(){
		this._element.getElements('._passed').removeClass('_passed');

		this._element.getElements('li').some(function(_el){
			if(_el === this._active_el) return true;

			_el.addClass('_passed');
		}.bind(this));
	}
});	